export default {
  title: {
    en: 'Sorry, the page you are looking for doesn’t exist or has been moved.',
  },
}
